import { Box, Typography } from "@mui/material";
import { GEOANALYTICS_VERSION } from "@/config/version";

type GeoAnalyticsFooterProps = {
  compact?: boolean;
};

export function GeoAnalyticsFooter({ compact = false }: GeoAnalyticsFooterProps) {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        px: { xs: 2, sm: 3 },
        py: compact ? 1.5 : { xs: 1.75, md: 2 },
        borderTop: 1,
        borderColor: "divider",
        bgcolor: "background.default"
      }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", textAlign: "center", lineHeight: 1.6 }}
      >
        © {year} GeoAnalytics v{GEOANALYTICS_VERSION}. Todos os direitos reservados.
      </Typography>
    </Box>
  );
}
